import Icon from "hardcover-ui/components/Icon";
import faStar from "icons/duotone/star.svg";
import Heading from "hardcover-ui/components/Heading";
import TextLink from "hardcover-ui/components/TextLink";
import useIsLoggedIn from "hooks/user/useIsLoggedIn";
import Avatar from "hardcover-ui/components/Avatar";
import useCurrentUser from "hooks/fragments/useCurrentUser";
import LocaleNumber from "components/ui/LocaleNumber";
import pluralize from "lib/pluralize";
import BookGroupBooks from "components/BookGroup/books/BookGroupBooks";
import { PageSerializersUsersShowPublic, UserSerializersComparisonByline } from "types/serializers";
import useCurrentUserId from "hooks/user/useCurrentUserId";

export default function ProfileSimilarBooks({ user, similarComparison }: {similarComparison: UserSerializersComparisonByline; user: PageSerializersUsersShowPublic }) {
  const isLoggedIn = useIsLoggedIn();
  const currentUserId = useCurrentUserId();
  const currentAvatar = useCurrentUser((u) => u?.image);

  if (!isLoggedIn || !similarComparison || similarComparison.similarBooksCount === 0 || currentUserId === user.id) {
    return <></>;
  }
  const books = similarComparison.commonFavorites.map((commonFavorite) => commonFavorite.book).slice(0, 12);

  return (
    <section className="space-y-4">
      <div className="flex flex-row justify-between items-baseline">
        <Heading level={2} size="md" className="flex flex-row space-x-2 items-center">
          <Icon icon={faStar} size="md" />
          <span className="flex flex-row -space-x-4">
            <Avatar image={user.image} size="sm" className="mr-2" alt={user.username} />
            <Avatar image={currentAvatar} size="sm" className="mr-2" alt="Your avatar" />
          </span>
          <span>Shared Reads</span>
        </Heading>
        <TextLink
          variant="secondary"
          href={`/@${user.username}/compare`}
        >
          <LocaleNumber number={similarComparison.similarBooksCount} /> shared {pluralize("read", similarComparison.similarBooksCount)}
        </TextLink>
      </div>

      <BookGroupBooks size="lg" books={books} context={{referrerId: user.id }} />
    </section>
  );
}
